<script setup>
import { computed, inject } from 'vue';
import { styleVars } from './shared.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const post = inject('tiqCurrentPost', null);
// A visitor never meets the slot's placeholder: with no real post
// to render it draws nothing, and only the editor keeps the stand-in.
const editing = inject('tiqEditorCanvas', false);

// Same as the Classic twin: the editor canvas gets placeholder text so
// the slot is visible, a live post with no excerpt renders nothing.
const excerpt = computed(() => {
    if (post) return post.excerpt || '';
    return 'Optional one-paragraph summary of the post.';
});
const align = computed(() => (['left', 'center', 'right'].includes(props.config.align) ? props.config.align : 'left'));
</script>

<template>
    <section v-if="(excerpt) && (post || editing)" :id="config.anchor_id || null" class="th-block th-post-excerpt" :style="styleVars(config)">
        <div class="th-wrap">
            <p class="th-post-excerpt__text" :class="`th-post-excerpt__text--${align}`">{{ excerpt }}</p>
        </div>
    </section>
</template>

<style scoped>
.th-post-excerpt__text {
    max-width: 820px;
    margin: 0 auto;
    padding: 4px 0 20px;
    font-size: clamp(19px, 2vw, 22px);
    line-height: 1.45;
    color: var(--text-sub, #3a3e38);
    text-wrap: pretty;
}
.th-post-excerpt__text--center { text-align: center; }
.th-post-excerpt__text--right { text-align: right; }
</style>
